"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserSettingsKey = void 0;
var UserSettingsKey;
exports.UserSettingsKey = UserSettingsKey;

(function (UserSettingsKey) {
  UserSettingsKey["AIR_PRODUCTION_LIMITS_CHART"] = "airProductionLimitsChart";
  UserSettingsKey["AIR_PRODUCTION_LOG_CHART"] = "airProductionLogChart";
  UserSettingsKey["DUPLICATED_CHARTS"] = "duplicatedWidgets";
  UserSettingsKey["FLOW_LOG_CHART"] = "flowLogChart";
  UserSettingsKey["LAST_PROJECT_OPENED"] = "last_project_opened";
  UserSettingsKey["PH_LOG_CHART"] = "phLogChart";
  UserSettingsKey["PROJECT_DASHBOARD_SETTINGS"] = "projectDashboardSettings";
  UserSettingsKey["WIDGET_FILTERS"] = "widgetFilters";
})(UserSettingsKey || (exports.UserSettingsKey = UserSettingsKey = {}));